// NATIVE 

// INSTALLED 
import { at } from 'lodash';
import { useField } from 'formik';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { theme } from '../../commons/theme';

// CUSTOM 





export const UploadButtonField = (props:any) => {

    const { label, accept, name, text, onChange, style, required, icon, ...rest } = props;
    const [field, meta] = useField(props);


    function _renderHelperText() {
      const [touched, error] = at(meta, 'touched', 'error');
      
      if (touched && error) {
          return error;
      }
    }

    const VisuallyHiddenInput:any = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    

    // console.log(formikProps.values)
  return (
    <>
     <Button
        style={{ ...style }}
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        onChange={ onChange }
        startIcon={icon || <CloudUploadIcon />}
        sx={{
            ...(style && style),
            ...( !text && { "& .MuiButton-startIcon": { margin: 0 } } )
        }}
    >
        {text}
        <VisuallyHiddenInput 
                  type="file" 
                  accept={accept} 
                  name={name} 
                  required={required} 
        />
    </Button>
    {
      (meta.touched && meta.error && true) && <p style={{ color: '#d32f2f' }}>{_renderHelperText()}</p>
    }
    
    </>
  )
}
